import { useQuery } from "react-query";
import { useParams } from "react-router-dom";
import API from "../../../services/API";
import useReorderSections from "./useReorderSections";

export default function useSections(){

    const {id} = useParams()

    const reorderSections = useReorderSections()

    return useQuery({

        queryKey: ['design', id, 'sections'],

        queryFn: () => API.get(`/design/courses/${id}/sections`)
            .then(r => reorderSections(r.data)),

        staleTime: 'Infinity',
        refetchInterval: false,
        refetchIntervalInBackground: false,
        refetchOnMount: false,
        refetchOnReconnect: false,
        refetchOnWindowFocus: false,
    })
};